import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-topic-list', {
  mixins: [eventListenerMixin],

  properties: {
    finishPage: Boolean,
    scrollLoadUrl: String,
  },

  ready() {
    if (!this.scrollLoadUrl) return;
    this.scrollLoadTrigger = this.querySelector('tr-scroll-load-trigger');
    if (!this.scrollLoadTrigger) return;

    this.listenTo(this.scrollLoadTrigger, {
      'tr-scroll-load-trigger:loading': this.loadMore.bind(this),
    });
  },

  loadMore() {
    const lastTopic = this.querySelector('.messages .message:last-of-type');
    if (!lastTopic || lastTopic.classList.contains('sticky')) {
      this.scrollLoadTrigger.parentNode.removeChild(this.scrollLoadTrigger);
    } else {
      $.ajax({
        url: this.scrollLoadUrl,
        method: 'get',
        data: {
          finish: this.finishPage,
          till: lastTopic.dataset.lastCommentAt,
        },
        dataType: 'script',
      });
    }
  },
});
